import { FilterOption } from '~/core/models';
import {
  FilterInput,
  SelectedFilterOptions,
  TypeOfFilter,
} from '~/core/types/sortAndFilter';

export const getSelectedFiltersOptions = (
  filters: TypeOfFilter[],
  selectedFilterOptionsProp?: SelectedFilterOptions
): SelectedFilterOptions => {
  const selectedFilterOptions: SelectedFilterOptions = {};

  filters.forEach(([filterCategory]) => {
    selectedFilterOptions[filterCategory] =
      selectedFilterOptionsProp?.[filterCategory] ?? [];
  });

  return selectedFilterOptions;
};

export const getSelectedFiltersMap = (
  filters: FilterInput
): Record<string, FilterOption[]> => {
  const selectedFilters: Record<string, FilterOption[]> = {};

  for (const key of Object.keys(filters)) {
    const currentFilters = filters[key];

    if (currentFilters) {
      selectedFilters[key] = currentFilters.filterOptions.filter(
        (option: FilterOption) => option.isSelected
      );
    }
  }

  return selectedFilters;
};
